import React from 'react';

const CaretDownIcon = () => {
  return (
    <svg
      className="c-CaretDownIcon"
      width="14"
      height="8"
      fill="none"
      viewBox="0 0 14 8"
    >
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1 1l6 6 6-6"
      ></path>
    </svg>
  );
};

export default CaretDownIcon;
